import '../../styles/ui/ui.scss'
const Title = ({text, size}) => (
    <header className={`header-title ${size}`}>
        <h1>
            {text}
        </h1>
    </header>
)
export default Title;